import { useMemo } from 'react';
import useTrackingCore from './core';
import { useAddOns, useMsci } from '@/store';

export default function usePaymentTracking() {
  const {
    ticketInsurance: { selected },
  } = useAddOns();

  const {
    msci: { selected: planSelected, bin },
  } = useMsci();

  const {
    trackEventWithTimeRemaining,
    trackEventWithCouponAndTimeRemaining,
    trackEventWithCouponValueAndTimeRemaining,
    trackLeavePageEvent,
  } = useTrackingCore();

  const paymentTrackingFunctions = useMemo(() => {
    return {
      paymentViewed: () => {
        trackEventWithCouponAndTimeRemaining('payment_viewed');
      },
      paymentMethodSelected: (paymentMethod) => {
        trackEventWithTimeRemaining('payment_method_selected', {
          payment_method: paymentMethod,
        });
      },
      purchase: ({ type, method }) => {
        trackEventWithCouponValueAndTimeRemaining('purchase', {
          purchase_type: type,
          payment_method: method,
          ticket_proctection: selected,
          bin,
          ...(planSelected ? { installmentPlan: planSelected } : {}),
        });
      },
      paymentAbandoned: ({ method, reason = 'manual_exit' }) => {
        trackLeavePageEvent('payment_abandoned', {
          payment_method_selected: method,
          reason,
        });
      },
    };
  }, [
    trackEventWithCouponAndTimeRemaining,
    trackEventWithCouponValueAndTimeRemaining,
    trackEventWithTimeRemaining,
    trackLeavePageEvent,
    bin,
    planSelected,
    selected,
  ]);

  return paymentTrackingFunctions;
}
